<template>
    <div class="rangePage uk-position-relative">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @searchFn="getListFn" @AddFn="AddFn" @DelFn="DelFn" @activeFn="activeFn"
            @cancelFn="cancelFn">
        </v-search>
        <div class="componentPage">
            <STable :req="customerList" :params="[SearchForm]" :columns="columns" ref="stable" @selectData="choozeTableFn">
            </STable>
            <!-- <tablePage
        :tableData="tableData"
        :loading="loading"
        @detailFn="detailFn"
        @choozeTableFn="choozeTableFn"
        @delFn="delFn"
        @statusFn="statusFn"
        :typeArray="typeArray"
      />

      <Pagination
        class="pagination"
        :total="total"
        :page.sync="SearchForm.iDisplayStart"
        :limit.sync="SearchForm.iDisplayLength"
        @pagination="getListFn"
      ></Pagination> -->
        </div>
        <Dialog :isShow.sync="isShow" :title.sync="title" ref="vForm" :statusArray="statusArray" :typeArray="typeArray" />

        <!-- 详情 -->
        <DetailDoalog v-if="detailObj" :detailIsShow.sync="detailIsShow" :title.sync="title" :detailObj="detailObj"
            :statusArray="statusArray" :typeArray="typeArray" ref="DetailDoalog" />
    </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js';
import publicMix from '@/utils/public.js';
import STable from '@/components/STable/STable.vue';
import { customerStatusConvert, customerTypeConvert } from '@/utils/convert';
import { customerList, customerDetail, customerRemove, customerActive, customerCancel } from '@/api/modules/range.js';

import tablePage from './Table.vue';
import Dialog from './dialog/AddDialog.vue';
import DetailDoalog from './dialog/Detail.vue';
import columns from './mixin/columns';

export default {
    mixins: [mixinForm, publicMix, columns],
    components: {
        tablePage,
        Dialog,
        DetailDoalog,
        STable
    },

    data() {
        return {
            customerList,
            customerStatusConvert,
            SearchForm: {
                isPersonal :0,
                code: null,
                status: null,
                type: null,
                name: null
            },
            formContent: [
                {
                    id: 1,
                    text: 'customer.name',
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true
                },
                {
                    id: 2,
                    text: 'customer.customer_status',
                    type: 'select',
                    paramsName: 'status',
                    selectParam: [],
                    isChooze: false
                }
            ],
            optareBtn: [
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.customer_status_active',
                    method: 'activeFn'
                },
                {
                    id: 3,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.customer_status_cancel',
                    method: 'cancelFn'
                }
            ],
            statusArray: [],
            typeArray: [],
            // 详情
            detailIsShow: false,
            detailObj: null,
            // 删除
            choozeTable: []
        };
    },
    created() {
        this.getInitData({ code: 'customer_status', type: 0 }, 1);
    },
    methods: {
        getInitData(object, num) {
            this.shareParamFn(object).then(({ result }) => {
                this.formContent[num].selectParam = this.changeIn18Data(result, num);
            });
        },
        changeIn18Data(result = [], num) {
            const array = [{ value: '', label: 'public.please', icon: num === 1 ? 'el-icon-thumb' : '' }];
            return array.concat(
                result.map(item => {
                    return {
                        value: item.code,
                        label: 'public.' + item.content,
                        icon: num === 1 ? (parseInt(item.code) === 1 ? customerStatusConvert(1).icon : customerStatusConvert(0).icon) : ''
                    };
                })
            );
        },
        resetFn() {
            this.SearchForm = {
                code: null,
                status: null,
                type: null,
                name: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            this.getListFn();
        },

        getListFn() {
            this.$refs.stable.getList();
            // this.loading = true;
            // customerList(this.SearchForm).then(({ result, pageInfo }) => {
            //     this.tableData = result;
            //     this.total = pageInfo.total
            // }).finally(() => {
            //     this.loading = false
            // })
        },
        AddFn() {
            this.title = 'customer.title_add';
            this.isShow = true;
            this.statusArray = [...this.formContent[1].selectParam].slice(1);
            this.$nextTick(() => {
                this.$refs.vForm.clearValidate();
            });
        },
        /** 详情 */
        detailFn(row) {
            this.detailIsShow = true;
            this.title = 'customer.title_detail';
            const array = [...this.formContent[1].selectParam].slice(1);
            this.statusArray = array.map(item => {
                item.value = Number(item.value);
                return item;
            });
            this.$nextTick(() => {
                // 压警告
                if (this.$refs.DetailDoalog) this.$refs.DetailDoalog.ismode = true;
            });
            customerDetail({ id: row.id }).then(({ result }) => {
                this.detailObj = result;
            });
        },
        /** 勾选表格 */
        choozeTableFn(array) {
            this.choozeTable = array;
        },
        /** 删除 */
        DelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            const ids = this.choozeTable.map(item => item.id).join(',');
            this.TODOTIPDEL(ids);
        },
        delFn(row) {
            customerRemove({ id: row.id }).then(({ result }) => {
                if (result === 200) {
                    this.getListFn();
                    this.$message.success(this.$t('public.tip_del_succ').toString());
                } else {
                    this.$message.error('public.tip_del_fail');
                }
            });
        },
        /**
         *
         * @param {*param 选中数据id} param string
         */
        TODOTIPDEL(param) {
            this.$confirm(this.$t('customer.tip_before_del'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    customerRemove({ id: param }).then(({ result }) => {
                        if (result === 200) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        } else {
                            this.$message.error('public.tip_del_fail');
                        }
                    });
                })
                .catch(() => { });
        },
        /** 激活与注销 */
        statusFn(row) {
            let httpUrl = customerActive;
            if (row.status === 1) {
                httpUrl = customerCancel;
            }

            httpUrl({ ids: [row.id] }).then(({ result, state }) => {
                if (result === 200) {
                    this.$message.success(row.status === 1 ? this.$t('customer.tip_cancelled') : this.$t('customer.tip_actived'));
                    this.getListFn();
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        activeFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            this.$confirm(this.$t('integration.are_you_sure_about_this_operation?'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    const ids = this.choozeTable.map(item => item.id);
                    customerActive({ ids }).then(({ result, state }) => {
                        if (result === 200) {
                            this.$message.success($t('integration.activation_successful'));
                            this.getListFn();
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => { });
        },
        cancelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));

            const ids = this.choozeTable.map(item => item.id);
            customerCancel({ ids }).then(({ result, state }) => {
                if (result === 200) {
                    this.$message.success($t('integration.logout_successful'));
                    this.getListFn();
                } else {
                    this.$message.error(state.msg);
                }
            });
        }
    },
    mounted() {
        this.$store.dispatch('carrierType');
    }
};
</script>

<style lang="scss" scoped>
.rangePage {
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    ::v-deep .el-icon-open {
        font-weight: bold;
    }

    ::v-deep .el-icon-turn-off {
        font-weight: bold;
        color: #ccc;
    }
}

// ::v-deep .el-icon-open {
//   font-weight: bold;
//   color: #22fd76;
// }

// ::v-deep .el-icon-turn-off {
//   font-weight: bold;
//   color: red;
// }
</style>
